import api from "@/services/api";

export default {
  addOption(payload) {
    return api
      .post(`online-documents/create-option/`, payload)
      .then((response) => response.data);
  },
  addDimension(payload) {
    return api
      .post(`online-documents/add-dimension/`, payload)
      .then((response) => response.data);
  },
  deleteDimension(payload) {
    return api
      .post(`online-documents/delete-dimension/`, payload)
      .then((response) => response.data);
  },
  addSpecialOption(payload) {
    return api
      .post(`online-documents/create-special-option/`, payload)
      .then((response) => response.data);
  },
  saveSpecialOption(payload) {
    return api
      .post(`online-documents/save-special-option/`, payload)
      .then((response) => response.data);
  },
  deleteSpecialOption(payload) {
    return api
      .post(`online-documents/delete-special-option/`, payload)
      .then((response) => response.data);
  },
  getOAAchievementGraphData(docID) {
    return api
      .get(`online-documents/get-oa-achievement-graph-data/?id=${docID}`)
      .then((response) => response.data);
  },
  getPageGraphData(docID, page) {
    return api
      .get(`online-documents/get-page-graph-data/?id=${docID}&page=${page}`)
      .then((response) => response.data);
  },
  deleteOption(payload) {
    return api
      .post("online-documents/delete-option/", payload)
      .then((response) => response.data);
  },
  getPageInfo(pageID, documentID) {
    return api
      .get(
        `online-documents/get-page-info/?page=${pageID}&document=${documentID}`
      )
      .then((response) => response.data);
  },
  getAIOAAdecuacy(payload) {
    const params = new URLSearchParams(payload).toString();
    return fetch(`/api/online-documents/get-ai-oa-adecuacy/?${params}`).then((response) => {
      return response.body;
    });
  },
  getAIOAMultiAdecuacy(payload) {
    const params = new URLSearchParams(payload).toString();
    return api.get(`online-documents/get-ai-oa-multi-adecuacy/?${params}`).then((response) => {
      return response.data;
    });
  },
  generateTextOptionsAI(payload) {
    return api
      .post(`online-documents/generate-text-options-ai/`, payload)
      .then((response) => response.data);
  },
  addUserTestTag(payload) {
    return api.post(`online-documents/add-user-test-tag/`, payload).then((response) => {
      return response.data;
    });
  },
  generateEjesAchievementAI(payload) {
    return api
      .post(`online-documents/generate-ejes-achievement-ai/`, payload)
      .then((response) => response.data);
  },
  addElementAchievement(payload) {
    return api
      .post(`online-documents/add-element-achievement/`, payload)
      .then((response) => response.data);
  },
  clearElementAchievements(payload) {
    return api
      .post(`online-documents/clear-element-achievements/`, payload)
      .then((response) => response.data);
  },
  resolveAchievementSource(payload) {
    return api
      .post(`online-documents/resolve-achievement-source/`, payload)
      .then((response) => response.data);
  }
};
